import {globalWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';
import {FrontConfig} from '../../srcCommon/bundler/bundlerDefineConfig';
import {ConfigState} from '../store/data/dataState';

declare global {
  interface Window {
    currentVersion: () => string;
  }
}

let value: string;

export function setupBuildVersion(config: ConfigState) {
  value = config.buildVersion;
}

export function getBuildVersion() {
  return value || 'unknown';
}

globalWindow.currentVersion = () =>
  `Git Commit: ${FrontConfig.GIT_COMMIT}\r\nBuild Timestamp: ${FrontConfig.BUILD_TIMESTAMP}`;
